import React from 'react';
import { Grid } from '@material-ui/core';
import classNames from 'classnames';

import { Tooltip } from 'core/components/tooltip';
import { Button } from 'core/components/button';
import { tooltipHoverTexts } from 'core/helpers/constants';
import { useSwapAppCoApp } from 'common/components/people/hooks';
import { useDisabledState, useHideEditControls } from 'common/disabled-context';
import SwapIcon from './swap.svg?react';
import useStyles from './swap-button.styles';

function SwapButton({ allowLicensedActions, formikPath }) {
  const classes = useStyles();
  const { onSwap, disableSwapButton } = useSwapAppCoApp({ formikPath, allowLicensedActions });
  const { disabled: globalDisabled } = useDisabledState();
  const hideEditControls = useHideEditControls();

  const disabled = disableSwapButton || globalDisabled;

  if (hideEditControls) {
    return null;
  }
  return (
    <Grid item>
      <Button
        className={classNames(classes.swapButton, {
          [classes.swapButtonDisabled]: disabled
        })}
        onClick={onSwap}
        disabled={disabled}
        color="secondary"
      >
        Swap Main and Co-Applicant
        <SwapIcon className={classes.swapIcon} />
      </Button>
      {disableSwapButton && (
        <Tooltip
          text={
            !allowLicensedActions
              ? tooltipHoverTexts.swapButtonDisabledForLicenseOrPermissions
              : tooltipHoverTexts.swapButtonDisabledNeedsSaved
          }
          label="More Info"
          placement="bottom"
          className={classes.swapTooltip}
        />
      )}
    </Grid>
  );
}

export default SwapButton;
